import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {SettingsEvent} from '../classes/settings-event.enum';
import {InteractionService} from './interaction.service';
import {SettingsType} from '../enums/settings-type.enum';

@Injectable({
  providedIn: 'root'
})
export class MouseService {

  private fractalSettingsEvents: BehaviorSubject<SettingsEvent>;
  private mouseMove: boolean;

  constructor(private interactionService: InteractionService) {
    this.fractalSettingsEvents = this.interactionService.fractalSettings;

    window.addEventListener('mousedown', (event) => this.onMouseDown(event));
    window.addEventListener('mouseup', (event) => this.onMouseUp(event));
    window.addEventListener('mousemove', (event) => this.onMouseMove(event));
    window.addEventListener('mousewheel', (event) => this.onMouseWheel(event));
  }

  onMouseDown(event: MouseEvent) {
    this.mouseMove = true;
  }

  onMouseUp(event: MouseEvent) {
    this.mouseMove = false;
  }

  onMouseMove(event: MouseEvent) {
    if (this.mouseMove) {
      this.fractalSettingsEvents.next(new SettingsEvent(SettingsType.DIRECTION_X, event.movementX));
      this.fractalSettingsEvents.next(new SettingsEvent(SettingsType.DIRECTION_Y, -event.movementY));
    }
  }

  onMouseWheel(event: WheelEvent) {
    this.fractalSettingsEvents.next(new SettingsEvent(SettingsType.ZOOM, event.wheelDelta));
  }
}
